<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 15%">
      <div style="padding-top: 30px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
        style="overflow: auto"
      >
        <div style="padding: 3%">
          <div style="width: 100%; display: inline-block; vertical-align: top">
            <div style="margin-top: 20px">
              <div style="display: inline-block; text-align: left; width: 15%">
                后台用户名
              </div>
              <el-input
                style="display: inline-block; width: 30%"
                v-model="username"
                placeholder="输入用户名"
              ></el-input>
            </div>
            <div style="margin-top: 20px">
              <div style="display: inline-block; text-align: left; width: 15%">
                后台密码
              </div>
              <el-input
                type="password"
                style="display: inline-block; width: 30%"
                v-model="password"
                placeholder="如需修改新密码，则输入该项，否则密码不改动"
              ></el-input>
            </div>
            <div style="margin-top: 40px">
              <el-button
                @click="onUpdateAdmin"
                style="display: inline-block; background-color: #1bb24b"
                type="success"
                >确认修改</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "billList",

  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      username: "",
      password: "",
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchAdmin();
  },
  computed: {},
  methods: {
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },
    // fetch admin detail
    onFetchAdmin() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "api/v1/fetchAdminDetail", {})
        .then((res) => {
          console.log(res.data.data);
          this.username = res.data.data.username;
          this.password = "";
          this.fullscreenLoading = false;
        });
    },

    // update admin detail
    onUpdateAdmin() {
      if (this.username == "") {
        this.$message({
          message: "若修改username必填",
          type: "warning",
        });
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "api/v1/updateAdminDetail", {
          username: this.username,
          password: this.password,
        })
        .then((res) => {
          this.$message({
            message: "更新成功",
            type: "success",
          });
          this.fullscreenLoading = false;
        });
    },
  },
};
</script>

